export const schedules = [
  { value: "TODAY_ONLY", label: "Today Only" },
  { value: "TODAY_TOMORROW", label: "Today & Tomorrow" },
  { value: "WEEK", label: "Week" },
];

export const lengths = [
  { value: 10, label: "10 min" },
  { value: 15, label: "15 min" },
  { value: 20, label: "20 min" },
  { value: 30, label: "30 min" },
  { value: 45, label: "45 min" },
];

// Pan Am Clinic ID test and prod
export const PAN_AM_ID = [
  "cc925464-3504-4914-833e-fcaf1fd5d283",
  "2a9360ed-9d2d-47ee-84b0-929ae55f2b36",
];
